const DateConstraintSuggestionView = Backbone.View.extend({
  events: {
    'click .js-dismiss': 'hideSuggestion',
  },

  initialize(options) {
    this.$el.addClass('expandDown');
  },

  hideSuggestion() {
    this.$el.hide();
  },

  destroyView() {
    this.undelegateEvents();
    this.remove();
  },
});

export default DateConstraintSuggestionView;



// WEBPACK FOOTER //
// ./js/backbone/views/date_constraint_suggestion_view.js